import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import close from "../../../assets/Icons/close.png";
import checkedImg from "../../../assets/Icons/photo-taken.png";
import dOneCheckedImg from "../../../assets/Icons/d-one-photo-taken.jpg"
import error from "../../../assets/svg/failed.svg";
import { useNavigate, useParams } from "react-router-dom";
import steps from "./steps";
import { clearImages } from "../../../Store/fullScan";
import { createScan, submitScan } from "../../../Services/APIs/scan";
import SuccessScreen from "./submitSuccess";
import { clearReports } from "../../../Store/reports";
import { clearHealth } from "../../../Store/teethHealth";
import { clearQuestionnaire } from "../../../Store/questionnaire";
import successImage from "../../../assets/onboarding-images/success.png";

import {


  buttonStyle,
  company_style_details,
  fontStyle,
  fontWeight,
  companyBucket,
} from "../../../Utils/tpscanStyle";

const ToothSelector = (props) => {
    
  const { dentalOfficeName } = useParams();
  const { setImageSide, setToothPicker } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { images, fullScanS3Folder } = useSelector((state) => state.fullScan);
  const { selectedOptions, reason } = useSelector(
    (state) => state.questionnaire
  );
  const [isLoading, setLoading] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);
  const [isError, setError] = useState(false);
  const [doneAlert, setAlert] = useState(false)

  const handleImageSide = (index) => {
    setImageSide(index);
    setToothPicker(false);
  };

  const submit = async () => {
    setLoading(true);
    const info = {
        uid: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
        folderName: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
        company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
        isIpad: localStorage.getItem("isUnileverIpad")
    }
    await submitScan(info)
      .then(async (response) => {
        if (localStorage.getItem("usertpi")) {
          localStorage.setItem(
            "tpscore",
            JSON.stringify(response.data?.data?.data)
          );
        }
        const { images, ...mlResults } = response?.data?.data?.data;
        const { pdf_url, name, ...report_score } = mlResults;
        localStorage.setItem("pdf", `${name}.pdf`);
        localStorage.setItem("pdf_url", pdf_url)
        createReport({ pdf_url, report_score });
      })
      .catch((error) => {
        setLoading(false);
        setError(true);
      });
  };

  const createReport = async ({ pdf_url, report_score }) => {
    const tooth = {
      front_teeth: "Tampak depan gigi",
      upper_jaw: "Rahang atas",
      lower_jaw: "Rahang bawah",
      left_side: "Right side",
      right_side: "Left side",
    };
    const report = {
      uid: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
      company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
      report_score,
      pdf_url,
      is_full_scan: true,
      user_looking_for: selectedOptions,
      reason,
      isIpad: localStorage.getItem("isUnileverIpad")
    };
    for (const key in tooth) {
      images.forEach((eachObj) => {
        if (tooth[key] === eachObj.title) {
          report[key] = eachObj.file;
        }
      });
    }
    await createScan(report)
      .then((response) => {
        localStorage.setItem("response", JSON.stringify(response.report));
        dispatch(clearImages());
        localStorage.setItem("isScanCompleted", true)
        localStorage.removeItem("reloaded")
        localStorage.removeItem("template")
        localStorage.removeItem("usertpi")
        localStorage.getItem("isUnileverIpad") ? navigate("/unilever/i-thanks") : navigate("/unilever/thanks")
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError(true);
      });
  };

  const ErrorUI = () => {
    return (
      <div className="h-full absolute top-0 z-10 w-full flex justify-center items-center bg-black/[0.3] backdrop-blur-sm">
        <div className="bg-white w-3/4 flex flex-col items-center p-5 rounded-md shadow-sm">
          <div className="text-end w-full">

            <button
              type="button"
              onClick={() => { setError(false) }}>
              <img src={close} className="w-6 h-6" alt="close" />
            </button>


          </div>
          <img src={error} alt="error" className=" w-40 h-40" />
          <p className="text-center my-5 font-medium">
            {" "}
            Maaf!! AI sedang mengalami kesulitan. Silakan coba lagi sebentar lagi
          </p>
          <div className=" w-full ">
            <button
              type="button"
              className="bg-black text-white w-full h-11 font-semibold text-base shadow-2xl"
              onClick={() => {
                localStorage.getItem("usertpi")
                  ? window.history.back()
                  : navigate(`/${dentalOfficeName}/dashboard`);
              }}
            >

              Dasbor
            </button>
          </div>
        </div>
      </div>
    );
  };

  const Button = (props) => {
    const { i, name, title } = props;
    const checked = images.find((eachObj) => eachObj.title === title);

    return (
      <>
        {checked ? (
          <img src={companyBucket === "done" ? dOneCheckedImg : checkedImg} alt="checked" className="w-20 h-20 mx-2 rounded-full" />
        ) : (
          <button
            className="w-20 h-20 text-xl text-center bg-white rounded-full shadow mx-2"
            onClick={() => {
              handleImageSide(i);
            }}
            style={companyBucket === "done" ? { fontSize: "16px" } : {}}
          >
            {name}
          </button>
        )}
      </>
    );
  };
  const doNavigate = () => {
    window.history.back()
  };

  return (
    <div className="h-full w-full bg-white absolute top-0">
      {isError && <ErrorUI />}

      <div className="h-3/4 relative bg-orange-100">
        <img
          src={successImage}
          alt="success"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-0 h-2/5 w-full bg-gradient-to-t from-white"></div>
      </div>
      <div className="w-full absolute bottom-4 px-5">
        <h1 className=" text-26 font-medium text-left leading-8">
          Pengambilan foto berhasil!
        </h1>
        <p className="text-base text-left mt-2">
          Kirim foto untuk Mendapatkan analisa dasar kesehatan gigi
        </p>
        <button
          type="button"
          className="bg-red-unilever text-white w-full h-11 mb-1 mt-5 font-semibold text-base shadow-2xl"
          onClick={submit}
          disabled={isLoading}
        >
          {isLoading ? (
            <div className="loader-container">
              <div className="loader dark-loader"></div>
            </div>
          ) : (
            <span> Kirim foto </span>
          )}
        </button>

      </div>
    </div>
  );
};

export default ToothSelector;
